import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import gsap from 'gsap';

@Component({
  selector: 'fgb-tab',
  standalone: true,
  imports: [CommonModule, FGBSharedModule],
  templateUrl: './tab.component.html',
  styleUrl: './tab.component.scss',
})
export class TabComponent implements AfterViewInit {
  @Input() selectedIndex = 0;
  @Input() minWidth: number | 'auto' = 'auto';
  @Input() tabs: string[] = [];
  @Input() isSmallVersion: boolean = false;
  @Input() isLeaderboard : boolean = false;
  @ViewChild('indicator', { static: true }) indicatorRef!: ElementRef;
  @ViewChild('tabsContainer', { static: true }) tabsContainerRef!: ElementRef;
  @Output() tabSelectionChange: EventEmitter<number> = new EventEmitter<number>();

  ngAfterViewInit(): void {
    this._init();
  }

  private _init(): void {
    const tab = this.tabsContainerRef.nativeElement.children[this.selectedIndex + 1];
    const tabRect = tab.getBoundingClientRect();
    const indicator = this.indicatorRef.nativeElement;
    gsap.set(indicator, {
      width: tabRect.width,
    });
    this.tabSelectionChange.emit(this.selectedIndex);
  }

  selectTab(index: number, event?: MouseEvent): void {
    const containerRect = this.tabsContainerRef.nativeElement.getBoundingClientRect();
    const tab = (event?.target as HTMLElement) || this.tabsContainerRef.nativeElement.children[index + 1];
    const tabRect = tab.getBoundingClientRect();
    const indicator = this.indicatorRef.nativeElement;

    const finalX = tabRect.left - containerRect.left;

    // Animate the indicator
    gsap.to(indicator, {
      duration: 0.5,
      x: finalX,
      ease: 'back.out(1.3)',
      onStart: () => {
        gsap.to(indicator, {
          duration: 0.3,
          width: tabRect.width,
          ease: 'power2.out',
        });
      },
    });

    gsap.fromTo(indicator, { scale: 0.95 }, { scale: 1, duration: 0.3, ease: 'power2.out' });

    this.selectedIndex = index;
    this.tabSelectionChange.emit(this.selectedIndex);
  }

  get tabStyle(): { [key: string]: string } {
    return {
      minWidth: this.minWidth === 'auto' ? 'auto' : `${this.minWidth}px`,
    };
  }
}
